import { DropdownAtom, type DropdownAtomOption } from "@/components/atoms/Dropdown/DropdownAtom";
import { classNames } from "@/utility/jsx";
import type React from "react";
import "./SingleDropdown.scss";

export type SingleDropdownOption<T extends string = string> = DropdownAtomOption<T>;

export type SingleDropdownProps<T extends string = string> = {
  options: readonly SingleDropdownOption<T>[];
  value?: T;
  onChange: (value: T, option: SingleDropdownOption<T>) => void;
  label?: React.ReactNode;
  description?: React.ReactNode;
  placeholder?: string;
  disabled?: boolean;
  error?: React.ReactNode;
  className?: string;
  "data-testid"?: string;
};

export function SingleDropdown<T extends string = string>({
  options,
  value,
  onChange,
  label,
  description,
  placeholder,
  disabled = false,
  error,
  className,
  "data-testid": dataTestId,
}: SingleDropdownProps<T>) {
  return (
    <div className={classNames("single-dropdown", className)} data-testid={dataTestId}>
      {label && <div className="single-dropdown__label">{label}</div>}
      {description && <div className="single-dropdown__description">{description}</div>}

      <DropdownAtom
        options={options}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        disabled={disabled}
        hasError={!!error}
      />

      {error && <div className="single-dropdown__error">{error}</div>}
    </div>
  );
}
